<template>
    <div>
        <Toolbar>
            <BackButton :to="__('subscriptions.bundles')" :href="$route('subscriptions.bundles')" />
        </Toolbar>

        <div class="card card-body">
            <pre>{{ bundle }}</pre>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/vue2';
import BackButton from "@components/BackButton.vue";
import Toolbar from "@components/Toolbar.vue";

export default {
    components: {Toolbar, BackButton, Link},

    props: {
        bundle: Object
    }
};
</script>
